module.exports = __webpack_public_path__ + "img/guide.f7b05736.png";